import Vue from 'vue'
import App from './App'
import router from './router'
import '@/permission'
import BootstrapVue from 'bootstrap-vue'
import { store } from './store/store'
import globals from './globals'
import Popper from 'popper.js'
import flatpickr from 'flatpickr'
import { Turkish } from 'flatpickr/dist/l10n/tr.js'
import VueGoogleApi from 'vue-google-api'
import Vuelidate from 'vuelidate'

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false
Vue.use(VueGoogleApi, {
  apiKey: 'b9xsJlq5kKP86imktezG2fdZ',
  clientId: '238984133766-o12rnd0n4jd66uajs97p1o6ekpgmum9a.apps.googleusercontent.com'
  // ux_mode: 'redirect',
  // redirect_uri: 'http://localhost:8080'
  /*  scope: 'space_separated_scopes', */
})

Vue.config.productionTip = false
flatpickr.localize(Turkish)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
// Global RTL flag
Vue.mixin({
  data: globals
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
